import { Card } from "../../../../table/module/poker_table/poker_table_common";

const {ccclass, property} = cc._decorator;

@ccclass
export default class K9Help{

    static AddChild(prefab:cc.Node,parent:cc.Node):cc.Node{
        if (parent === null || prefab === null) {
            cc.log('prefab or parent is null');
            return null;
        }
        let node = cc.instantiate(prefab);
        node.position = cc.Vec3.ZERO;
        node.angle = 0;
        node.scale = 1;
        node.active = true;
        parent.addChild(node);
        return node;
    }

    static delay(node: cc.Node , callback : ()=>void , delay : number):cc.Action{
        let delayAction = cc.delayTime(delay);
        let func = cc.callFunc(()=>{
            if (callback) {
                callback();
            }
        })
        let sequence = cc.sequence(delayAction , func);
        node.runAction(sequence);
        return sequence;
    }

    static setNodeString(item:cc.Node,str:string){
        let richComp = item.getComponent(cc.RichText)
        if(richComp)
        {
            richComp.string = str;
        }else{
            let labelComp = item.getComponent(cc.Label)
            if(labelComp)
            {
                labelComp.string = str;
            }
        }
    }

    static schedule(node : cc.Node , callback : ()=>void , delay : number) : cc.Action
    {
        let delayAction = cc.delayTime(delay);
        let sequence = cc.sequence(delayAction , cc.callFunc(callback));
        let action = cc.repeatForever(sequence);
        node.runAction(action);
        return action;
    }

    static scheduleTimes(node : cc.Node , callback : ()=>void , delay : number,times:number) : cc.Action
    {
        let delayAction = cc.delayTime(delay);
        let sequence = cc.sequence(delayAction , cc.callFunc(callback));
        let action = cc.repeat(sequence,times);
        node.runAction(action);
        return action;
    }

    static rotateActionScaltoEx(node:cc.Node,time:number,scaleByTime:number, callback:Function, endCallBack:Function){
        let scalTo = cc.scaleTo(0.18,1.25);
        let callFunc = cc.callFunc(()=>{
            K9Help.rotateActionEx(node,time,scaleByTime,callback,endCallBack);
        });
        let seq1 = cc.sequence(scalTo,callFunc);
        node.stopAllActions();
        node.runAction(seq1);
    }

    static rotateActionEx(node:cc.Node,time:number,scaleByTime:number, callback:Function, endCallBack:Function){
        var run = cc.callFunc(function(){
            node.setScale(0.01, 1)
            if (callback != null){ callback() }
        })

        var endRun = cc.callFunc(function(){
            node.setScale(1, 1)
            if (endCallBack != null){ endCallBack() }
        })
        node.stopAllActions();
        let seq = cc.sequence(cc.scaleTo(time, 0.01, 1), run , cc.scaleTo(time, 1, 1), endRun)
        let sqwan = cc.spawn(cc.scaleTo(scaleByTime, 1),seq)

        node.runAction(sqwan)
    } 

    //设置动画停止
    static setAnimToEnd(animName:string,anim:cc.Animation){
        if (!anim) {
            return;
        }
        let duration = anim.getAnimationState(animName).duration;
        anim.play(animName,duration);
    }

    //排序卡牌
    static sortCards(cards:number[]){
        if (!cards) {
            return;
        }
        cards.sort((a:number,b:number)=>{
            let ma = Card.codeToIndex(a);
            let mb = Card.codeToIndex(b);
            return ma-mb;
        })

        //处理牌型QKA                                             
        if (K9Help.isQKA(cards)) {
            let pokercard = cards.shift();
            cards.push(pokercard);
        }
    }

    //对牌型的牌型进行检测
    static isQKA(cards:number[]):boolean{
        cards = cards.concat([]);
        if (cards.length == 3) {
            cards.sort((a:number,b:number)=>{
                let ma = Card.codeToIndex(a);
                let mb = Card.codeToIndex(b);
                return ma-mb;
            })

            if (Card.codeToIndex(cards[0]) == 1
            && Card.codeToIndex(cards[1]) == 12
            && Card.codeToIndex(cards[2]) == 13) {
                return true;
            }
        }
        return false;
    }
}
